import React from 'react'
import PropTypes from 'prop-types'
import { Chip } from '@mui/material'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'

/**
 * Story 113 (S141-S145, RN49-RN55) — the ONE preparation label, reused wherever preparation must be
 * visible: the four station widgets' headers, and the shop-floor screen's station card and detail.
 *
 * D-I6: ONLY preparation is labelled. Execution looks exactly as it does today, with no label -- that
 * asymmetry is deliberate, and it is also what keeps preparation and execution from collapsing into a
 * single "running" state in the operator's eyes.
 *
 * RN50 contracts the three colours. The BORDER is a FUNCTIONAL requirement, not decoration: it cuts
 * the label out of the widget's dark background, which the fill alone does not do (it reads as part
 * of the panel). They live in an exported constant so the contract is pinned by test rather than
 * buried in a style block.
 *
 * RN55: informative and nothing else -- not the error colour, not the shape of a warning, not
 * actionable, and it disables nothing by itself.
 */
export const PREPARATION_LABEL_COLORS = {
  fill: '#5A2480',
  border: '#AFA9EC',
  text: '#FFFFFF'
}

const PreparationLabel = ({ visible = false, size = 'small' }) => {
  const { t_ } = useSmartTranslation()

  if (!visible) return null

  return (
    <Chip
      // Hueco 2 (PO, 2026-09-03): the very same `Preparation` key the start-mode modal uses for its
      // preparation option. No key of its own, so the story's new-key count stays at 11.
      label={t_('Preparation')}
      size={size}
      variant='filled'
      sx={{
        backgroundColor: PREPARATION_LABEL_COLORS.fill,
        color: PREPARATION_LABEL_COLORS.text,
        border: `1px solid ${PREPARATION_LABEL_COLORS.border}`,
        fontWeight: 700,
        // RN53: with a long FO name the NAME yields space (it truncates with an ellipsis) and the
        // label stays whole -- it never shrinks and never wraps onto a broken line.
        whiteSpace: 'nowrap',
        flexShrink: 0
      }}
    />
  )
}

PreparationLabel.propTypes = {
  visible: PropTypes.bool,
  size: PropTypes.string
}

export default PreparationLabel
